import request from '@/services/interceptor.js'


export const get_oreClienti = (par, data) => {
    return request({
        url: '/clienti/ore/' + par,
        method: 'post',
        data: data,
        loadingBar: true
    })
};

// Dashboard Analytics: se la richiesta fallisce viene mostrato un avviso (errorToast)
const analytics = (url, data) => {
    return request({
        url: url,
        method: 'post',
        data: data,
        loadingBar: true,
        errorToast: true
    })
};

export const get_kpi_ore = (data) => analytics('/clienti/kpi', data);

// Andamento
export const get_dati_mensili_ore = (data) => analytics('/clienti/dati-mensili', data);
export const get_confronto_anni_ore = (data) => analytics('/clienti/confronto-anni', data);
export const get_stagionalita_ore = (data) => analytics('/clienti/stagionalita', data);
export const get_previsione_ore = (data) => analytics('/clienti/previsione', data);
export const get_statistiche_periodo_ore = (data) => analytics('/clienti/statistiche-periodo', data);

// Composizione
export const get_top_clienti_ore = (data) => analytics('/clienti/top-clienti', data);
export const get_heatmap_clienti_ore = (data) => analytics('/clienti/heatmap-clienti', data);

// Confronti
export const get_confronto_multi_anno_ore = (data) => analytics('/clienti/confronto-multi-anno', data);
export const get_variazione_yoy_ore = (data) => analytics('/clienti/variazione-yoy', data);
export const get_analisi_trimestri_ore = (data) => analytics('/clienti/analisi-trimestri', data);

// Resa dei clienti e clienti a rischio
export const get_resa_clienti = (data) => analytics('/clienti/resa-clienti', data);
export const get_dettaglio_cliente_ore = (data) => analytics('/clienti/resa-clienti/dettaglio', data);
